import { GetInvoiceExpandParameterInner } from "@wingspanhq/wingspan-api-sdk";

/**
 * The expansions every `getInvoice` / `getPayable` read asks for.
 *
 * One shared set per entity rather than a per-screen set, because a `Set`
 * serialises to `{}` in the React Query cache key: two reads of the same
 * invoice asking for *different* expansions hash to the same entry, so
 * whichever ran first wins and the other screen silently gets a payload
 * missing its expansion. Keeping the set identical everywhere makes that
 * collision harmless.
 *
 * `attachments` matters beyond the detail view: the invoice/payable forms seed
 * their attachment field from the same payload and reconcile bind/detach
 * against it on save, so a read without it presents an invoice as having no
 * files (WIN-15660).
 */
export const INVOICE_EXPAND = new Set([
  GetInvoiceExpandParameterInner.SPLITS_PAYEE,
  GetInvoiceExpandParameterInner.ATTACHMENTS
]);

// Payables reuse the invoice expansion enum. A payer reading a payable gets
// `payee` and never `payer` (the opposite, inaccessible perspective is omitted).
export const PAYABLE_EXPAND = new Set([
  GetInvoiceExpandParameterInner.PAYEE,
  GetInvoiceExpandParameterInner.ATTACHMENTS
]);

/**
 * The two `unit` values the line-item form can produce on its own. A rate of
 * `other` sends the free-text unit the user typed instead.
 */
export const LINE_ITEM_HOUR_RATE = "Hour";
export const LINE_ITEM_UNIT_RATE = "Unit";
